import { defaultServer } from '~/api/def/servers/defaultServer';

export const documentEndpoint = {
  server: defaultServer,
  path: 'document',
  description: 'Document endpoint',
};
